import React from 'react';
import {
  buildFeatureOptions,
  buildBuyingSchemeOptions,
} from '../../../utils/additionalFiltersUtils';

function MobileAdditionalFiltersField({
  filterData,
  selectedFeatures,
  selectedBuyingSchemes,
  onFeatureChange,
  onBuyingSchemeChange,
  disabled = false,
}) {
  const featureOptions = buildFeatureOptions(filterData);
  const buyingSchemeOptions = buildBuyingSchemeOptions(filterData);

  // Combine all additional filters for display
  const allAdditionalFilters = [
    ...featureOptions.map((option) => ({
      ...option,
      type: 'feature',
      checked: selectedFeatures.includes(option.value),
      onChange: disabled ? undefined : () => onFeatureChange(option.value),
    })),
    ...buyingSchemeOptions.map((option) => ({
      ...option,
      type: 'buyingScheme',
      checked: selectedBuyingSchemes.includes(option.value),
      onChange: disabled ? undefined : () => onBuyingSchemeChange(option.value),
    })),
  ];

  return (
    <div>
      <fieldset className="px-4">
        <legend className="block font-medium text-black text-sm mb-3">
          More filters
        </legend>

        <div className="grid grid-cols-2 gap-4">
          {buyingSchemeOptions.length > 0 && (
          <div>
            <p className="block font-light text-xs mb-2">Buying schemes</p>

            <div className="space-y-3">
              {buyingSchemeOptions.map((filter) => (
                <label key={filter.value} className="flex items-center gap-3">
                  <input
                    type="checkbox"
                    checked={selectedBuyingSchemes.includes(filter.value)}
                    onChange={
                      disabled
                        ? undefined
                        : () => onBuyingSchemeChange(filter.value)
                    }
                    className="w-4 h-4 border border-[#EBEBEB] bg-grey-100"
                    disabled={disabled}
                  />
                  <span
                    className={`text-sm font-light ${
                      disabled ? 'opacity-50' : ''
                    }`}
                  >
                    {filter.label}
                  </span>
                </label>
              ))}
            </div>
          </div>
)}
          <div>
            <p className="block font-light text-xs mb-2">Must haves</p>
            <div className="space-y-3">
              {featureOptions.map((filter) => (
                <label key={filter.value} className="flex items-center gap-3">
                  <input
                    type="checkbox"
                    checked={selectedFeatures.includes(filter.value)}
                    onChange={
                      disabled ? undefined : () => onFeatureChange(filter.value)
                    }
                    className="w-4 h-4 border border-[#EBEBEB] bg-grey-100"
                    disabled={disabled}
                  />
                  <span
                    className={`text-sm font-light ${
                      disabled ? 'opacity-50' : ''
                    }`}
                  >
                    {filter.label}
                  </span>
                </label>
              ))}
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  );
}

export default MobileAdditionalFiltersField;
